import { createContext, useContext, useEffect, useState } from 'react';
import { initTokenManager } from '@src/service/tokenManager';

interface User {
  displayName: string;
  mail?: string;
  sAMAccountName?: string;
  roles?: string[];
}

export const AuthContext = createContext<{
  user: User | null;
  loading: boolean;
  setUser: (user: User | null) => void;
}>({
  user: null,
  loading: true,
  setUser: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUserLoggedIn();
  }, []);

  const checkUserLoggedIn = async () => {
    const token = sessionStorage.getItem('access_token');
    if (token) {
      initTokenManager();
      fetchUserDetails(token);
    } else {
      setLoading(false);
    }
  };

  const fetchUserDetails = async (token: string) => {
    try {
      const userInfo = sessionStorage.getItem('User');
      if (userInfo) {
        setUser(JSON.parse(userInfo));
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error('Error fetching user details', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
